/* eslint-disable import/prefer-default-export */
import React from 'react';

import 'what-input';
import './src/styles/main.scss';

// custom typefaces
import 'typeface-nunito';
import 'typeface-roboto';
